/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import doubleclickEvents from "../doubleclick-events";

// custom data has weird names, make it more dev friendly
// To check usage, search repo for the string "doubleclickEvents."
// and see the names of the params that are passed to this method.
// The 'uX' values must stay the same, but you can change the keys -
// as long as you also change them in the doubleClickEvents calls.
var CUSTOM_DATA_MAP = {
    path: "u1",
    view: "u2",
    query: "u3",
    stock_status: "u4",
    is_icon: "u5",
    gender: "u6",
    product_type: "u7",
    category: "u8",
    subcategory: "u9",
    final_price_from: "u10",
    final_price_to: "u11",
    discount_from: "u12",
    color: "u13",
    size: "u14",
    designer_slug: "u15",
    retailer_slug: "u16",
    id: "u17",
    atc_country: "u18",
    atc_medium: "u19",
    analytics_session_id: "u21",
    order: "ord",
    quantity: "qty"
};

var ACCOUNT_MAP = {
    "4837424": CUSTOM_DATA_MAP
};

var LIFE_CYCLE_EVENT_MAP = {
    purchased: doubleclickEvents.SESSION_PURCHASED,
    repeat: doubleclickEvents.SESSION_REPEAT,
    loyal: doubleclickEvents.SESSION_LOYAL
};

function DoubleclickTransport(eventNames) {
    this._eventNameValues = _.values(eventNames);
}

_.extend(DoubleclickTransport.prototype, {
    send: function(events) {
        var promises = [];

        // with all the events sent
        events.forEach(event => {
            var eventName = null;
            var eventData = null;

            if (event.type === "doubleclick_event") {
                // Skip if eventName not a value of doubleclick-events
                if (this._eventNameValues.indexOf(event.data.eventName) < 0) {
                    return null;
                }

                eventName = event.data.eventName;
                eventData = event.data.customData;
            } else if (event.type === "page_view") {
                // First page view events
                if (event.data.page_view_count == 1) {
                    promises.push(...this._sendSessionEvents(event.data));
                }
            }

            if (eventName) {
                var url = this._eventToDoubleclickUrl(eventName, eventData);
                if (url) {
                    // create an iframe for each, that then destroys itself when complete
                    promises.push(this._createDoubleclickIframe(url));
                }
            }
        });

        return Promise.all(promises);
    },

    _sendSessionEvents: function(sessionData) {
        var promises = [];
        var url = this._eventToDoubleclickUrl(doubleclickEvents.ANALYTICS_SESSION_ID, {
            analytics_session_id: sessionData.session_id
        });
        promises.push(this._createDoubleclickIframe(url));

        var eventName = LIFE_CYCLE_EVENT_MAP[sessionData.life_cycle_stage];
        if (eventName) {
            var url = this._eventToDoubleclickUrl(eventName, {
                analytics_session_id: sessionData.session_id
            });
            promises.push(this._createDoubleclickIframe(url));
        }

        return promises;
    },

    _labelEventName: function(eventName) {
        var eventParts = eventName.split("/");
        return {
            accountId: eventParts[0],
            type: eventParts[1],
            cat: eventParts[2]
        };
    },

    _createDoubleclickIframe: function(url) {
        return new Promise(
            function(resolve, reject) {
                var frame = document.createElement("iframe");
                frame.width = 1;
                frame.height = 1;
                frame.style.display = "none";
                // when this frame loads, then it should remove itself
                frame.addEventListener("load", _.partial(this._removeIframe, resolve));
                frame.addEventListener("error", _.partial(this._removeIframe, reject));
                frame.src = url;
                document.body.appendChild(frame);
            }.bind(this)
        );
    },

    _eventToDoubleclickUrl: function(eventName, EventData) {
        // create a set of new doubleclick data to send, using the dc names,
        // rather than the friendly names
        var labelledEventName = this._labelEventName(eventName);
        var doubleclickData = {
            src: labelledEventName.accountId,
            type: labelledEventName.type,
            cat: labelledEventName.cat
        };

        // get key value map for given account id, return null if it does not exist
        var customDataMap = ACCOUNT_MAP[labelledEventName.accountId];
        if (!customDataMap) {
            return null;
        }

        // parse each one, ensuring the friendly names are replaced
        _.each(EventData, function(data, dataKey) {
            var realKey = customDataMap[dataKey] || dataKey;
            doubleclickData[realKey] = data;
        });

        // if ord isn't specified, we want to create a random number (for cache reasons)
        if (!doubleclickData.ord) {
            doubleclickData.ord = (Math.random() * 10000000000000).toString();
        }

        // make the final event string
        var eventString = _.reduce(
            doubleclickData,
            function(memo, value, key) {
                return memo + ";" + encodeURIComponent(key) + "=" + encodeURIComponent(value);
            },
            ""
        );

        // return the url
        return (
            "https://" +
            labelledEventName.accountId +
            ".fls.doubleclick.net/activityi" +
            eventString
        );
    },

    _removeIframe: function(callback) {
        document.body.removeChild(this);
        callback();
    }
});

var instance = new DoubleclickTransport(doubleclickEvents);

// add the doubleclick transport class so we can test it
// this has to be a singleton
instance.DoubleclickTransport = DoubleclickTransport;

export default instance;

